import { Col, Row } from "antd";
import { jwtDecode, JwtPayload } from "jwt-decode";
import { AccessTokenPayload, RefreshTokenPayload } from "../types/tokens";
import { apiSendData } from "../services/apiHandler";
import { AccessLevel, Address, RowLevelAction } from "../types/types";
import { isTokenExpired } from "./object";
import { authApis } from "./ApiURLs";
import { PostRequest } from "./api";
import { geoLoactionApis } from "./ApiURLs";
import dayjs from 'dayjs';
import { Notification } from "../components/notification/notification";

const controller = new AbortController();

type accessTokenType = {
  clientId: string;
  profileId: string;
};


let enableRefresh = true;

const isRefreshTokenRequired = (): Boolean => {

  let user = getUserFromLocalStorage<AccessTokenPayload>();

  if (user && user.accessToken) {
    const decoded: JwtPayload = jwtDecode<JwtPayload>(user.accessToken);
    const exp: number = decoded.exp! * 1000;

    const refreshTime = parseInt(process.env.REACT_APP_REFRESH_TOKEN_TIME_LIMIT || "25");
    const time30MinMore = Date.now() + (refreshTime * 60 * 1000);

    if (exp < time30MinMore) {
      return true;
    }
  }

  return false;
}

// Function to handle 401 responses
function checkFor401(response: Response): Response {

  if (response.status === 401) {
    localStorage.removeItem("user");
    triggerLogout();
    enableRefresh = true;
  }

  return response; // Pass the response along
}

// Wrapper around fetch to apply middleware
export function fetchWithMiddleware(url: string, options?: RequestInit): Promise<Response> {
  return fetch(url, options).then(response => checkFor401(response)).catch(error => {
    // Handle network errors or other unexpected errors, this issue happenning because of CORS when session expires.
    if (error instanceof TypeError) {
      doLogout();
    }

    console.error('Fetch error:', error);
    return Promise.reject(error);

  });
}

export const doLogout = async () => {

  try {

    await PostRequest(authApis.logoutApi, {}, "logout").catch((error) => {

      localStorage.removeItem("user");
      Notification("error", "Failed to logout Properly");
      triggerLogout();
    });

    localStorage.removeItem("user");

  } catch (error: any) {
    localStorage.removeItem("user");
    Notification("error", "Failed to logout Properly");
  };

};

export const triggerLogout = () => {
  const logoutEvent = new Event('logout');
  window.dispatchEvent(logoutEvent);
};


export const authHeader: any = () => {

  let userAccessToken: any | undefined = undefined;

  let user = getUserFromLocalStorage<AccessTokenPayload>();

  if (isRefreshTokenRequired()) {
    fetchResponseToken(user);
  }


  //if token is expired move to login page
  if (user.accessToken && isTokenExpired(user.accessToken)) {
    discardTokenAndMoveRedirectToLogin();
    return {};
  }



  if (user && user.accessToken) {
    userAccessToken = { Authorization: "Bearer " + user.accessToken };
    return userAccessToken;
  }

  return {};
};

export const getLoggedInUserEcode = (): string | undefined => {
  let user = getUserFromLocalStorage<AccessTokenPayload>();
  if (user && user.username) {
    const usernameTokens = user.username.split('@');
    return user.username.split('@').slice(0, usernameTokens.length - 1).join('@');
  }
  return undefined;
}

const discardTokenAndMoveRedirectToLogin = () => {
  localStorage.removeItem("user");
  // BroadcastChannelHandler.getInstance().sendLogoutMessage();
}

const fetchResponseToken = async (user: any) => {

  try {
    if (!enableRefresh) {
      return;
    }
    enableRefresh = false;
    const res = await getAccesTokenFromRotatedRefreshToken(user.refreshToken, user.accessToken);
    // set local storage with latest value first and then return
    let updatedUserInfo: AccessTokenPayload = {
      ...user,
      accessToken: res.accessToken,
      refreshToken: res.refreshToken,
    };
    localStorage.setItem("user", JSON.stringify(updatedUserInfo));
    enableRefresh = true;
    return { Authorization: "Bearer " + res.accessToken };
  } catch (error) {
    //when the refresh token is expired take to sign in page..
    // BroadcastChannelHandler.getInstance().sendLogoutMessage();
    enableRefresh = true;
    return {};
  }
}

const getAccesTokenFromRotatedRefreshToken = (
  refreshToken: string,
  accessToken: string
): Promise<RefreshTokenPayload> => {
  let endpoint: string = "auth/api/refresh-token";

  const headers: any = {
    "Content-Type": "application/json",
    authorization: `Bearer ${accessToken}`,
  };

  let data: any = {
    refreshToken: `${refreshToken}`,
  };

  return new Promise<RefreshTokenPayload>((resolve, reject) => {
    apiSendData(endpoint, controller, "POST", headers, data, resolve, reject);
  });
};

function getUserFromLocalStorage<ArgType>(): ArgType {

  let data = localStorage.getItem("user");
  let user: ArgType = data ? JSON.parse(data) : {};
  return user;
}

export const getLoggedInUserModuleAccess = (moduleId: string, moduleAccessLevel?: AccessLevel): AccessLevel => {
  let user = getUserFromLocalStorage<AccessTokenPayload>();
  if (user && user.accessToken) {
    let accessToken: accessTokenType = jwtDecode<accessTokenType>(
      user.accessToken
    );
    if (accessToken.profileId === "admin" || moduleId === "") {
      return "TRANSFER" as AccessLevel;
    }
    return moduleAccessLevel ?? ("NONE" as AccessLevel);
  }
  return "NONE" as AccessLevel;
};

export const isActionAllowedToUser = (
  userAccessLevel: AccessLevel,
  action: any
): boolean => {
  return (
    (action.toUpperCase() === "TRANSFER" &&
      getIndexOfAccessLevel(userAccessLevel) ===
      getIndexOfAccessLevelFromVal(AccessLevel.TRANSFER)) ||
    (action.toUpperCase() === "EMAIL" &&
      getIndexOfAccessLevel(userAccessLevel) >=
      getIndexOfAccessLevelFromVal(AccessLevel.EDIT)) ||
    (action.toUpperCase() === "WHATSAPP" &&
      getIndexOfAccessLevel(userAccessLevel) >=
      getIndexOfAccessLevelFromVal(AccessLevel.EDIT)) ||
    (action.toUpperCase() === "DOWNLOAD" &&
      getIndexOfAccessLevel(userAccessLevel) >=
      getIndexOfAccessLevelFromVal(AccessLevel.EDIT)) ||
    (action.toUpperCase() === "GENERATE" &&
      getIndexOfAccessLevel(userAccessLevel) >=
      getIndexOfAccessLevelFromVal(AccessLevel.EDIT)) ||
    (action.toUpperCase() === "ALL" &&
      getIndexOfAccessLevel(userAccessLevel) >=
      getIndexOfAccessLevelFromVal(AccessLevel.EDIT)) ||
    (action.toUpperCase() === "DATATABLEFILTER" &&
      getIndexOfAccessLevel(userAccessLevel) >=
      getIndexOfAccessLevelFromVal(AccessLevel.EDIT)) ||
    (action.toUpperCase() === "DELETE" &&
      getIndexOfAccessLevel(userAccessLevel) >=
      getIndexOfAccessLevelFromVal(AccessLevel.DELETE)) ||
    (action.toUpperCase() === "VIEW" &&
      getIndexOfAccessLevel(userAccessLevel) !==
      getIndexOfAccessLevelFromVal(AccessLevel.NONE)) ||
    ((action.toUpperCase() === "CREATE" || action.toUpperCase() === "CREATEWITHCONTEXT") &&
      getIndexOfAccessLevel(userAccessLevel) >=
      getIndexOfAccessLevelFromVal(AccessLevel.CREATE)) ||
    (action.toUpperCase() === "BULKUPLOAD" &&
      getIndexOfAccessLevel(userAccessLevel) >=
      getIndexOfAccessLevelFromVal(AccessLevel.CREATE)) ||
    (action.toUpperCase() === "EDIT" &&
      getIndexOfAccessLevel(userAccessLevel) >=
      getIndexOfAccessLevelFromVal(AccessLevel.EDIT))
  );
};

export const getIndexOfAccessLevel = (accessLevel: AccessLevel): number => {
  return Object.keys(AccessLevel).indexOf(accessLevel);
};

export const hasText = (item: string): boolean => {
  return item !== null && item !== undefined && item !== "";
}
export const getIndexOfPlatformAction = (platformAction: RowLevelAction): number => {
  return Object.keys(RowLevelAction).indexOf(platformAction);
};

export const getIndexOfAccessLevelFromVal = (
  accessLevel: AccessLevel
): number => {
  return Object.values(AccessLevel).indexOf(accessLevel);
};

export const capitalizeOnlyFirstLetter = (input: string): string => {
  return input.charAt(0).toUpperCase() + input.slice(1).toLowerCase();
}

export const getIndexOfPlatformActionFromVal = (
  platformAction: RowLevelAction
): number => {
  return Object.values(RowLevelAction).indexOf(platformAction);
};

export function getEnumKeyByEnumValue(myEnum: any, enumValue: any) {
  let keys = Object.keys(myEnum).filter(x => myEnum[x] === enumValue);
  return keys.length > 0 ? keys[0] : null;
}

export const createViewFormField = (sections: []) => {
  let formFields = [] as any;
  if (sections?.length > 0) {
    sections?.map((item: any) => {
      if (item?.viewForm) {
        formFields = item?.viewForm;
      }
    });
  }
  return formFields;
};

export const createViewModal = (formField: any, formdata: any) => {
  if (formField && formdata) {
    return (
      formField &&
      formField?.map((item: any) => {
        return (
          <Row>
            <Col
              style={{
                display: "flex",
                flexDirection: "row",
                width: "30%",
                marginTop: "10px",
                backgroundColor: "#eee",
                height: "40px",
                alignItems: "center",
                justifyContent: "space-between",
                borderRadius: "6px",
                padding: "6px",
              }}
            >
              <label style={{ fontSize: "16px" }}>{item?.dispName}:</label>
              <span style={{ fontSize: "16px", fontWeight: "500" }}>
                {formdata[item?.field] || "N/A"}
              </span>
            </Col>
          </Row>
        );
      })
    );
  }
};

export const isGenerateUrl = (url: string): boolean => {
  return url.includes("/generate-url-info");
}

export const countProperties = (arr: Record<string, any>[]) => {
  // Initialize counters
  let totalProperties = 0;
  let nullProperties = 0;

  // Iterate through each object in the array
  arr.forEach(obj => {
    // Iterate through each property in the object
    for (let key in obj) {
      if (obj.hasOwnProperty(key)) {
        // Increment total properties count
        totalProperties++;

        // Check if the property has a null value
        if (obj[key] === null) {
          nullProperties++;
        }
      }
    }
  });

  // Return the result as an object
  return {
    totalProperties,
    nullProperties
  };
}

export const getLatLongForGivenAddress = async (address: Address): Promise<any> => {

  const endpoint: string = geoLoactionApis.tripCoordinatesApi;

  const data = {
    addressLine1: address.addressLine1,
    addressLine2: address.addressLine2,
    addressLine3: address.addressLine3,
    city: address.city,
    state: address.state,
    pinCode: address.pinCode
  };

  return PostRequest(endpoint, data).then((response) => {
    return { latitude: response.data.latitude, longitude: response.data.longitude };
  })
    .catch((error) => {
      // Request failed, handle the error
      console.error(error);
      return { error: error };
    });
};


export function copyToClipboard(value: string): void {
  const textarea = document.createElement('textarea');

  // Set the value of the textarea to the specified value
  textarea.value = value;

  // Append the textarea to the document
  document.body.appendChild(textarea);

  // Select the text in the textarea
  textarea.select();

  // Execute the copy command
  document.execCommand('copy');

  // Remove the textarea from the document
  document.body.removeChild(textarea);
}

export function getCurrentDateFormatted() {
  const now = new Date();
  const year = now.getFullYear();
  const month = String(now.getMonth() + 1).padStart(2, '0'); // Months are zero-based, so +1
  const day = String(now.getDate()).padStart(2, '0');

  return `${year}-${month}-${day}`;
}

export function getEncodedPassword(password: string) {

  let encodedPassword = btoa(password)
  let incrementalCount = 0;
  let modifiedEncodedPassword = "";
  for (let i = 0; i < encodedPassword.length; i++) {
    modifiedEncodedPassword += encodedPassword[i];
    modifiedEncodedPassword += (++incrementalCount) % 10;
  }

  return modifiedEncodedPassword;

}

export const disabledDate = (current: any | dayjs.Dayjs, rules: any) => {
  if (rules?.startDate || rules?.default === "currentDate") {
    if (Number(rules?.minDate) > 0) {
      return !(
        current.isBefore(dayjs().add(Number(rules.minDate.substring(1)), "day")) &&
        current.isAfter(dayjs().add(Number(rules.minDate.substring(1)) + 1, "day"))
      );
    } else if (Number(rules?.minDate) === 0) {
      return !(
        current.isBefore(dayjs().add(rules.maxDate, "day")) &&
        current.isAfter(dayjs().subtract(Number(rules.minDate.substring(1)) + 1, "day"))
      );
    } else {
      return !(
        current.isBefore(dayjs().add(Number(rules.maxDate.substring(1)), "day")) &&
        current.isAfter(dayjs().subtract(Number(rules.minDate.substring(1)) + 1, "day"))
      );
    }
  }

  current = dayjs(rules?.startDate);
  return !(
    current.isBefore(dayjs().add(rules?.maxDate, "day")) &&
    current.isAfter(dayjs().subtract(rules?.minDate.substring(1), "day"))
  );
};



export const filterNullValues = (obj: any) => {
  // Check if obj is a stringified JSON and parse it if so
  if (typeof obj === 'string') {
    try {
      obj = JSON.parse(obj);
    } catch (e) {
      // If parsing fails, return the original object
      return obj;
    }
  }

  // Create a new object to store the filtered key-value pairs

  const filteredObj: any = {};
  // Iterate over the keys of the input object
  for (const key in obj) {
    // Check if the value is not null (you can also check for undefined if needed)
    if (obj[key] !== null) {
      // Add the key-value pair to the filtered object
      filteredObj[key] = obj[key];
    }
  }

  return filteredObj;

}